/* Restore the existing provider widget; no payment math, cart listeners or provider changes. */
(() => {
  'use strict';
  const start = () => document.querySelectorAll('[data-wh-paytomorrow]').forEach(slot => {
    if (slot.dataset.whPtBound) return;
    slot.dataset.whPtBound = 'true';
    const root = slot.closest('[data-wh-root]') || slot.closest('[id^="MainProduct-"]');
    const price = root?.querySelector('[data-wh-price]');
    if (!price) return;
    let busy = false, last = '', timer, attempts = 0;
    const current = () => {
      const node = price.querySelector('.price-item--sale') || price.querySelector('.price-item--regular');
      return node && { node, signature: node.textContent.trim() + '|' + slot.dataset.ptPrice };
    };
    const refresh = async () => {
      if (!slot.isConnected || busy) return;
      const selected = current();
      if (!selected || selected.signature === last) return;
      if (!window.PayTomorrow || typeof window.PayTomorrow.mpeInit !== 'function') {
        if (++attempts < 40) timer = setTimeout(refresh, 250);
        return;
      }
      attempts = 0; busy = true;
      selected.node.setAttribute('data-wh-pt-current-price', '');
      slot.replaceChildren();
      try {
        await window.PayTomorrow.mpeInit({
          debugMode: false, enableMoreInfoLink: false, logoColor: 'original',
          maxAmount: 10000, maxTerm: 24, minAmount: 500,
          mpeSelector: '[data-wh-paytomorrow]', priceSelector: '[data-wh-pt-current-price]',
          storeDisplayName: 'MRCOOL DIY Direct', publicId: '71e2c05dfa93b1e782f8f2efd8c781d3'
        });
        last = selected.signature;
        slot.dataset.whPtResult = slot.querySelector('.__pt-mpe-text-amount') ? 'rendered' : 'provider-no-offer';
        slot.dataset.whPtEquipmentPrice = slot.dataset.ptPrice || '';
      } catch (_) {
        slot.replaceChildren(); slot.dataset.whPtResult = 'unavailable';
      } finally {
        selected.node.removeAttribute('data-wh-pt-current-price'); busy = false;
        if (current()?.signature !== selected.signature) schedule();
      }
    };
    const schedule = () => { clearTimeout(timer); timer = setTimeout(refresh, 80); };
    new MutationObserver(schedule).observe(price, { childList: true, subtree: true, characterData: true });
    new MutationObserver(schedule).observe(slot, { attributes: true, attributeFilter: ['data-pt-price'] });
    window.addEventListener('load', schedule, { once: true });
    refresh();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
